import { Link } from 'react-router-dom';
import PageShell from '@/components/feature/PageShell';
import PageHero from '@/components/feature/PageHero';
import { locations } from '@/mocks/locations';
import { locationPageImages } from '@/mocks/pages';

export default function LocationsPage() {
  return (
    <PageShell title="FIRE CLUB Locations | Smash Burger Counters & Hours">
      <PageHero
        sticker="locations"
        title={<>Find the <span className="text-accent-500">fire.</span></>}
        intro={<>Two counters, same rules. Walk in, order up, <span className="hand text-accent-500 text-xl">eat it hot.</span></>}
      />
      <section className="wrap py-14 md:py-20 grid grid-cols-1 gap-14">
        {locations.map((loc, i) => (
          <article key={loc.id} id={loc.id} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 items-center ${i % 2 ? 'lg:[&>*:first-child]:order-2' : ''}`}>
            <div className="lg:col-span-7 aspect-[3/2] poster-frame hard-drop">
              <img src={locationPageImages.find((p) => p.id === loc.id)?.image || loc.image} alt={`FIRE CLUB ${loc.name}`} title={`FIRE CLUB ${loc.name} burger bar`} className="h-full w-full object-cover object-center" />
            </div>
            <div className="lg:col-span-5">
              <div className="flex flex-wrap items-center gap-3">
                <span className="display text-[44px] text-accent-500">{loc.no}</span>
                <span className="sticker !text-[14px] bg-primary-500 text-foreground-950 tilt-r">{loc.status}</span>
              </div>
              <h2 className="h-section mt-3">{loc.name}</h2>
              <dl className="mt-6 text-[15px]">
                <div className="grid grid-cols-[110px_1fr] items-center min-h-14 py-3 border-t-2 border-dashed border-foreground-300">
                  <dt className="hand text-sm text-foreground-600">address</dt>
                  <dd className="font-medium">{loc.address}</dd>
                </div>
                {loc.hours.map((h) => (
                  <div key={h.day} className="grid grid-cols-[110px_1fr] items-center h-14 border-t-2 border-dashed border-foreground-300">
                    <dt className="hand text-sm text-foreground-600">{h.day}</dt>
                    <dd className="tabular-nums font-medium">{h.time}</dd>
                  </div>
                ))}
              </dl>
              <p className="mt-5 text-sm text-foreground-700">Exact address and map will be posted here before opening day.</p>
            </div>
          </article>
        ))}
      </section>
      <section className="bg-accent-500 text-background-50 border-t-[2.5px] border-foreground-950 wrap py-14 md:py-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <h2 className="h-section">Want to know when we open?</h2>
        <Link to="/contact" className="btn-poster btn-paper">Get in touch <i className="ri-arrow-right-line" /></Link>
      </section>
    </PageShell>
  );
}